import { render, staticRenderFns } from "./ContentComponent.vue?vue&type=template&id=3755fe83&"
import script from "./ContentComponent.vue?vue&type=script&lang=js&"
export * from "./ContentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports